module.exports = __webpack_public_path__ + "resources/img/img_coolfilter1_m.f6183fa19f627f0274235cef6d65870f.png";